// window.onSubmit = function(token) {
//   var form = $('.ajaxForm');
//   var data = form.serialize();

//   // -- Remove any existing error messages from previous attempts --
//   $('.form__notifications .msg').fadeOut();

//   if ($('#g-recaptcha-response').val() !== '') {
//     var submit = [];
//     form.find('input[required]').each(function(index, input) {
//       if (input.value == '' || ($(this).attr('type') == 'checkbox' && $(this).prop('checked') == false)) {
//         submit.push(false);
//       } else {
//         submit.push(true);
//       }
//     });
//     // console.log(submit);
//     if($.inArray(false, submit) !== -1){
//       $('html, body').animate({
//         scrollTop: form.offset().top - 100
//       }, 'slow'); 
//       $('.form__notifications .error').delay(400).fadeIn();
//     } else {
//       $.ajax({
//         type: 'post',
//         url: window.location.href,
//         dataType: 'json',
//         data: data,
//         beforeSend: function(response) {
//           form.find('button[type=submit]').prop('disabled', true);
//         },
//         success: function(response) {
//           // console.log(response);
//           $('html, body').animate({
//             scrollTop: form.offset().top - 100
//           }, 'slow');        
//           if (response.success) {
//             console.log('success');
//             // -- Display notifications --
//             if ($('#iWantToDownloadTheFile').prop('checked') == true) {
//               $('.form__notifications .success__download').delay(400).fadeIn();
//             } else {
//               $('.form__notifications .success').delay(400).fadeIn();
//             }
//             setTimeout(function(){
//               form[0].reset();
//             }, 400);

//           } else {
//             console.log('error');
//             // -- Display notifications --
//             $('.form__notifications .error').delay(400).fadeIn();
//           }
//         },
//         error: function(response) {
//           console.log('error');
//           console.log(response);
//           // -- Display notifications --
//           $('.form__notifications .error').delay(400).fadeIn();
//         },
//         complete: function(response) {
//           form.find('button[type=submit]').prop('disabled', false);
//         }
//       });
//     }
//   }
// };


// var errorFunc = function(){
//   console.log('errorFunc');
//   $('.form__notifications .error').delay(400).fadeIn();
//   return;
// }

// -- label animation --
$(document).ready(function(){
  var inputs = $('.ajaxForm input, .ajaxForm textarea');
  inputs.on('focusin', function(){
    $(this).prev('label').addClass('active');
  });
  inputs.on('focusout', function(){
    if (!$(this).val()) {
      $(this).prev('label').removeClass('active');
    }
  });
});